import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { AuthGuard } from './security/auth.guard';
import { LoginComponent } from './security/login/login.component';
import { ImportsListComponent } from './imports/imports-list/imports-list.component';
import { ScheduleViewComponent } from './schedule/schedule-view/schedule-view.component';
import { ReportsListComponent } from './reports/reports-list/reports-list.component';
import { DashboardViewComponent } from './dashboard/dashboard-view/dashboard-view.component';
import { ForgotPasswordComponent } from './security/forgot-password/forgot-password.component';
import { NewPasswordComponent } from './security/new-password/new-password.component';
import { ChangePasswordComponent } from './security/change-password/change-password.component';


const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: DashboardViewComponent
      },
      {
        path: 'job',
        loadChildren: () => import('./job/job.module').then(mod => mod.JobModule),
      },
      {
        path: 'import-list',
        component: ImportsListComponent
      },
      {
        path: 'report-list',
        component: ReportsListComponent
      },
      {
        path: 'schedule-view',
        component: ScheduleViewComponent
      },
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot',
    component: ForgotPasswordComponent
  },
  {
    path: 'newpass',
    component: NewPasswordComponent
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent
  }


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
